import { Link, NavLink } from 'react-router-dom';

import logoBig from '../images/logos/logo-big.png';
import logoSmall from '../images/logos/logo-small.png';

import settings from '../settings/index.js';

import "../styles/Navigation.css";


export default function Navigation() {
    return (
        <div className="Navigation">
            <Link to="/" className="logo">
                <img className="hide-small" src={logoBig} />
                <img className="show-small" src={logoSmall} />
            </Link>

            <aside>
                <NavLink
                    className={({ isActive }) => "hide-small nav-link" + (isActive ? " active" : "")}
                    to="/search/45.706/-37.354/2/">
                    Jobs
                </NavLink>

                <NavLink
                    className={({ isActive }) => "hide-small nav-link" + (isActive ? " active" : "")}
                    to="/about/">
                    About
                </NavLink>

                <a href={settings.DASH} className="button hollow white">
                    <i className="fa fa-plus" aria-hidden="true" />
                    <span>ADD JOBS</span>
                    <span className="beta">beta</span>
                </a>
            </aside>
        </div>
    );
}
